module.exports = __webpack_public_path__ + "static/media/xegotech-wings-logo.be30b6aa.png";